export const ONE_DRIVE_ROOT_FOLDER = "root";
export const USER_ONE_DRIVE_BASE = "/me/drive";

export const MISSING_LICENSE_MESSAGE =
    "User does not have a SharePoint Online license";
export const NO_CONSENT_MESSAGE = "User declined to consent to access the app";
export const CANCELLED_LOGIN_MESSAGE = "User cancelled login";
export const INTERACTION_IN_PROGRESS_MESSAGE =
    "Login interaction already in progress";
